
import { IChartData } from "../types";

export const hasOnlyOneValue = (data: IChartData[]): boolean => {
  const validValues = data
  .filter((item: IChartData) => item.visibility !== null)
  .map((item: IChartData) => item.visibility);

  return validValues.length === 1;
};